import React from 'react';
import { motion } from 'framer-motion';
import ProfileImage from '../Images/cropped anurag img.jpg'; // Update the path to your image
import { saveAs } from "file-saver";
import resume from '../Pdfs/Anurag Gaiwal Resume.pdf';
import { FaLinkedin } from 'react-icons/fa';

const Home = () => {
  const buttonVariants = {
    hover: {
      scale: 1.1,
      transition: { duration: 0.3 }
    }
  };

  const handleDownloadResume = (event) => {
    event.preventDefault();
    saveAs(resume, "Anurag Gaiwal Resume");
  };

  return (
    <div className="h-screen bg-white flex items-center justify-center px-4 md:px-8 lg:px-16">
      <div className="flex flex-col md:flex-row items-center space-y-8 md:space-y-0 md:space-x-8">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center md:text-left"
        >
          <h1 className="text-2xl md:text-4xl font-bold">Hello, my name is Anurag Gaiwal</h1>
          <br />
          <p className="text-xl md:text-3xl font-semibold">I am a Full Stack Web Developer</p>
          <motion.div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mt-4">
            <motion.button
              variants={buttonVariants}
              whileHover="hover"
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
              onClick={handleDownloadResume}
            >
              Download Resume
            </motion.button>
            <motion.a
              href="https://www.linkedin.com/in/anurag-gaiwal/"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
              className="flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              <FaLinkedin className="mr-2" />
              LinkedIn
            </motion.a>
          </motion.div>
        </motion.div>
        <div>
          <motion.img
            src={ProfileImage}
            alt="Anurag Gaiwal"
            className="w-full md:w-auto h-48 md:h-96 object-cover"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          />
        </div>
      </div>
    </div>
  );
  
};

export default Home;
